export const setContent = content => ({
  type: "CONTEXT_BAR_SET_CONTENT",
  data: content
});
